/**
 * The client's status palette (legacy Ucode options): every status label in
 * the console, order statuses and generic tones alike, uses these pairs.
 * The dark theme derives its tint from `color` (see `.status-pill` in index.css).
 */
export const STATUS_PALETTE = {
  green: { color: '#0d8246', background: '#e5f6ed' },
  red: { color: '#c92a2a', background: '#fbe8e8' },
  purple: { color: '#6741d9', background: '#f0ebf8' },
  blue: { color: '#1971c2', background: '#e7f5ff' },
  gray: { color: '#495057', background: '#f1f3f5' },
  orange: { color: '#e67700', background: '#fdf3d8' },
} as const

export type StatusColor = keyof typeof STATUS_PALETTE

/** One look for every status label: a rounded tag; its size follows Appearance → Размер элементов. */
export const statusPillClass =
  'status-pill inline-flex h-[calc(var(--spacing)*7*var(--ui-size))] items-center justify-center gap-1.5 whitespace-nowrap rounded-[calc(7px*var(--radius-scale))] px-[calc(var(--spacing)*3*var(--ui-size))] text-[length:calc(12.5px*var(--text-scale)*var(--ui-size))] font-medium leading-none'

/** Steady width for a column of statuses, following the control size. */
export const statusPillMinWidth = 'min-w-[calc(var(--spacing)*20*var(--ui-size))]'
